<template>
    <div class="exp-run-page">
        <div class="soft-list" v-show="!isRemote && softwares.length > 0">
            <div class="soft-title">仿真软件</div>
            <div class="soft-item" v-for="soft in softwares" :key="soft.id" @click="clickSoftLocal(soft)">
                <img :src="soft.icon | filterUrl" />
                {{ soft.name }}
            </div>
        </div>
        <div :class="{
            'exp-run-main': true,
            'is-full': isFull
        }" ref="main">
            <div class="main-left" :class="{'left-full': !isRemote }">
                <div class="left-tabs">
                    <span :class="{
                        active: type == 'doc'
                    }" @click="type = 'doc'">实验文档</span>
                    <span :class="{
                        active: type == 'report'
                    }" @click="type = 'report'">实验报告</span>
                    <span class="left-tabs-close" @click="closeSoftWare(true)" v-if="!isRemote">退出实验</span>
                    <img class="full-img" src="~@/assets/imgs/ic_full_screen_document.png" @click="isFull = !isFull" />
                </div>
                <keep-alive>
                    <component :is="typeComp[type]" :expContentType="expContentType" :baseUrl="baseUrl" :uid="uid" :isSave="isSave" :showDoc="true" :newReport="newReport" :isStatus="isStatus" :expRecordInfo="expData" @exit="closeSoftWare(true)"/>
                </keep-alive>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { filterMarkdownHtml } from '@/utils/doc'
import { getMyExpDetail } from '@/api/lab/experiment'
import { getDetail } from '@/api/lab/lesson'
import { getStartupUrl } from '@/api/auth/jwt'
import expRunDoc from './components/exp-run-doc'
import expRunReport from './components/exp-run-report'

import { baseUrl } from "@/config/env";


export default {
    components: { expRunDoc, expRunReport },
    data () {
        return {
            expUid:'',
            lessonUid:'',
            expName:'',
            appArg:'',
            baseUrl:'',
            expContentType:null,
            newReport:'',
            uid: '', // 学生实验记录UID
            startType: '', // 开始实验类型   local 本地实验  remote 远程实验
            isFull: false,
            deskFull: false, // 是否桌面全屏
            expData: {},
            typeComp: { 'doc': 'expRunDoc', 'report': 'expRunReport' },
            type: 'doc',
            isRemote: false, // 是不是远程
            showDoc: false, // 是否展示文档
            softwares: [], // 仿真软件
            isSave: false, // 是否保存实验报告
            isStatus: false,
        }
    },
    computed: {
        ...mapGetters(['userInfo', 'token']),
        typeIsRemote () {
            return this.startType === 'remote'
        }
    },
    created () {
        const { uid, type, labExpUid, lessonUid, expUid } = this.$route.params
        this.startType = type
        this.uid = uid
        this.baseUrl = baseUrl
        this.labExpUid = labExpUid
        this.lessonUid = lessonUid
        this.expUid = expUid
    },
    mounted () {
        window.history.pushState(null, null, document.URL)
        this.$nextTick(() => {
            getMyExpDetail(this.uid).then(res => {
                const {
                    //       uid,
                 name, status } = res
                this.expName = name
                this.expContentType = res.expContentType
                if( res.report ) this.newReport = res.report
                if( status == 2) this.isStatus = true
                if(res.softs) {
                    const softList  = JSON.parse(res.softs)
                    this.softwares = softList
                    // if (softList.length > 0) {
                    //     const software = softList[0]
                    //     const { mode } = software
                    //     if (mode == 2) { // 远程
                    //         this.isRemote = true
                    //         this.setCurrentExpInfo({
                    //             uid,
                    //             name,
                    //             type: this.startType,
                    //             labExpUid: this.labExpUid
                    //         })
                    //     }
                    // }
                }else {
                    const html = filterMarkdownHtml(res)
                    const { softInfos } = html
                    this.softwares = softInfos
                    // if (this.typeIsRemote && softInfos.length > 0) {
                    //     const software = softInfos[0]
                    //     const { mode } = software
                    //     if (mode == 2) { // 远程
                    //         this.isRemote = true
                    //         this.setCurrentExpInfo({
                    //             uid,
                    //             name,
                    //             type: this.startType,
                    //             labExpUid: this.labExpUid
                    //         })
                    //     }
                    // }
                }
                // const html = filterMarkdownHtml(res)
                // const { softInfos } = html
                // this.softwares = softInfos
                this.expData = res
            }).catch(err => {
                window.console.error(err)
                this.$message.error(err.message || err.type || err)
                this.$router.go(-1)
            })
            getDetail(this.lessonUid).then(res=>{
                const { lessonName } = res
                this.lessonName = lessonName
            })
        })
    },
    methods: {
        ...mapActions(['setCurrentExpInfo']),
        /**
         * 关闭当前的仿真软件
         */
        closeSoftWare (close = false) {
            if (close) {
                this.setCurrentExpInfo(null)
                this.deskFull = true
                this.isSave = true
            }
            const { labUid } = this.expData
           if (labUid) {
             const { path } = this.$route
             let newPath = `/lesson/${labUid}/type/exp`
             if (path !== newPath)
                this.$router.push(`/lesson/${labUid}/type/exp`)
             }
        },
        /**
         * 点击调起本地仿真软件
         */
        clickSoftLocal (soft) {
            let appArg = JSON.stringify(soft.appprama)
            let params = {
                softId: soft.id,
                appArg: appArg,
                labExpUid: this.labExpUid,
                lessonUid: this.lessonUid,
                lessonName: this.lessonName,
                expUid: this.expUid,
                userExpRecordUid: this.uid,
                expName:this.expName
            }
            if(soft.caseUid) params.caseUid = soft.caseUid
            getStartupUrl(params).then(res=>{
                window.location.href = res
            })
        },
    }
}
</script>

<style lang="less" scoped>
@import "~@/assets/css/exp-runing";
.exp-run-page {
    .left-tabs-close {
        float: right;
        margin-right: 36px;
    }
    .soft-list {
        top: 142px;
        right: 1px;
        z-index: 999;
        width: 85px;
        min-height: 100px;
        border: 1px solid #e7e7e7;
        position: absolute;
        background-color: #fff;
        overflow: hidden;
        min-height: calc(100% - 220px);
        .soft-title {
            color: #333;
            text-align: center;
            width: 66px;
            height: 43px;
            line-height: 43px;
            padding-top: 9px;
            margin: 0 auto;
            border-bottom: #f0f0f0 1px solid;
            font-size: 13px;
            cursor: default;
        }
        .soft-item {
            display: block;
            text-align: center;
            width: 66px;
            height: 76px;
            margin: 0 auto;
            border-bottom: #f0f0f0 1px solid;
            color: #666;
            text-decoration: none;
            overflow: hidden;
            font: 12px arial;
            cursor: pointer;
            img {
                width: 36px;
                height: 36px;
                display: block;
                margin: 10px auto 5px;
                cursor: pointer;
            }
            &:hover {
                background-color: #ebeef5;
            }
        }
    }
    .exp-run-main {
        .main-right {
            width: 65%;
            height: 100%;
            margin-left: 35%;
            position: relative;
            .vm-area {
                height: 100%;
                box-shadow: -3px -1px 2px 0 #e0d6d6;
                .desktop-content {
                    width: 100%;
                    height: 100%;
                    position: absolute;
                    overflow: hidden;
                    .display {
                        width: 100%;
                        height: 100%;
                        #display {
                            width: 100%;
                            height: 100%;
                            overflow: auto;
                            display: flex;
                            // justify-content: center;
                            // align-items: center;
                            background: #000;
                        }
                    }
                }
                .action-btn {
                    position: absolute;
                    width: 28px;
                    font-size: 14px;
                    height: 94px;
                    background-color: #464646;
                    color: #fff;
                    text-align: center;
                    padding: 8px;
                    cursor: pointer;
                    z-index: 1100;
                }
                .hide {
                    top: 40%;
                    border-radius: 7px 0 0 7px;
                    left: -28px;
                }
                .show {
                    top: 40%;
                    border-radius: 0 7px 7px 0;
                    left: 0px;
                }
                .tools-bar {
                    width: 0;
                    height: 100%;
                    position: absolute;
                    right: 0;
                    transition: width ease-in-out 0.5s;
                    background-color: rgba(255, 255, 255, 0.9);
                    box-shadow: -1px 0 0 rgba(70, 70, 70, 0.25);
                    z-index: 9999;
                    &.tb-show {
                        width: 200px;
                    }
                    .btn-list {
                        margin-top: 72px;
                        text-align: center;
                        > * {
                            width: 70%;
                            display: inline-block;
                            &:not(:last-child) {
                                margin-bottom: 12px;
                            }
                        }
                        .title-time {
                            time {
                                font-size: 2em;
                            }
                        }
                        .el-input {
                            display: inline-table;
                        }
                    }
                    .tool-list {
                        margin: 40px 0 0 50px;
                        .tool {
                            margin: 20px 0;
                            position: relative;
                            cursor: pointer;
                            img {
                                vertical-align: middle;
                                width: 22px;
                            }
                            .tool-title {
                                font-size: 16px;
                                margin-left: 10px;
                                position: absolute;
                                top: 1px;
                            }
                        }
                    }
                }
                .tools-hide {
                    top: 30%;
                    right: 200px;
                    height: 115px;
                    border-radius: 7px 0 0 7px;
                }
                .tools-show {
                    top: 30%;
                    right: 0px;
                    height: 115px;
                    border-radius: 7px 0 0 7px;
                }
            }
        }
        .full {
            width: 100%;
            margin-left: 0%;
        }
        &.is-full {
            .main-right {
                width: 0;
                margin-left: 100%;
            }
        }
    }
    .clipboard-body {
        .text {
            font-size: 16px;
            line-height: 2em;
        }
        .el-textarea {
            margin: 10px 0;
        }
    }
}
</style>
